export default {
  labels: {
    dont_have_account: '¿No tienes cuenta? ',
  },
  title: '¡Únete a {{name}}!',
  default_program_name: 'Club de Recompensas',
  buttons: {
    sign_up: 'Regístrate',
  },
};
